(() => {
  const initializeRail = (root) => {
    if (root.dataset.carouselReady === 'true') return;

    const rail = root.querySelector('[data-category-rail]');
    const previous = root.querySelector('.mishop-generic-collection__arrow--prev');
    const next = root.querySelector('.mishop-generic-collection__arrow--next');
    if (!rail || !previous || !next) return;

    root.dataset.carouselReady = 'true';

    const sync = () => {
      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    };

    previous.addEventListener('click', () => rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' }));
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  };

  document.querySelectorAll('.mishop-generic-collection').forEach(initializeRail);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.mishop-generic-collection').forEach(initializeRail);
  });
})();
